import { createApp, h, provide } from 'vue';
import { createApolloProvider } from '@vue/apollo-option';
import { DefaultApolloClient } from '@vue/apollo-composable';
import VueGTag from 'vue-gtag';
import { sentryInit } from '@/services/sentry';
import { setOnSessionInvalid } from '@/services/api/cognito';
import { isChunkLoadError, recoverFromChunkLoadError } from '@/utils/chunk-load-error';
import { isAbortError } from '@/utils/abort-error';
import analyticsConfig from '../analytics-config';
import App from '@/App';
import router from '@/router';
import store from '@/store';
import defaultClient from '@/services/apollo-client';
import '@/styles/main.scss';
import '@cyhnkckali/vue3-color-picker/dist/style.css';

const apolloProvider = createApolloProvider({ defaultClient });

const app = createApp({
  setup: () => {
    provide(DefaultApolloClient, defaultClient);
  },
  render: () => h(App),
});

sentryInit(app);

window.addEventListener('error', (event) => {
  if (!isChunkLoadError(event.error)) return;
  event.preventDefault();
  recoverFromChunkLoadError();
}, true);

window.addEventListener('unhandledrejection', (event) => {
  if (isChunkLoadError(event.reason)) {
    event.preventDefault();
    recoverFromChunkLoadError();
    return;
  }
  if (isAbortError(event.reason)) {
    event.preventDefault();
  }
});

app.use(router);
app.use(store);

setOnSessionInvalid(() => {
  if (!store.getters.isAuthenticated) return;
  store.dispatch('logout');
  store.dispatch('setAuthReady', true);
  if (router.currentRoute.value.name !== 'login') {
    router.push({ name: 'login' });
  }
});

app.use(apolloProvider);
app.use(VueGTag, analyticsConfig);
app.mount('#app');
